import Icon, { IconTypes } from "shared/ui/icon";
import Text from "shared/ui/typography/Text";
import { concatClassnames } from "shared/utils/concatClassnames";

const WhatsappWidget = () => {
  const whatsappLink = "https://api.whatsapp.com/send/?phone=310103072889";

  return (
    <div
      className={concatClassnames(
        "gg-px-4 gg-py-2.5 gg-flex gg-items-center",
        "gg-text-green-900 gg-border-y gg-border-green-700 gg-bg-green-400 gg-text-sm "
      )}
    >
      <Icon name={IconTypes.WHATSAPP} className="gg-w-5 gg-h-6 gg-mr-2.5" />

      <div>
        <Text className="gg-font-bold">Even snel overleggen?</Text>
        <Text>Stuur ons een berichtje of foto via WhatsApp.</Text>
      </div>

      <a
        href={whatsappLink}
        target="_blank"
        className="gg-block gg-bg-green-900 gg-py-3 gg-px-4 gg-text-white gg-font-bold gg-ml-auto gg-text-xs gg-text-center"
        rel="noreferrer"
      >
        Start een chat
      </a>
    </div>
  );
};
export default WhatsappWidget;
